module.exports = __webpack_public_path__ + "static/media/bj.a35b44c8.svg";